export default "__VITE_ASSET__Du7ns5qF__"